
import Vue from 'vue';

interface ISearchMessageComputed {
  total: number;
  loading: boolean,
  suggestion: string;
}

export default Vue.extend<{}, {} ,ISearchMessageComputed ,{} >({
	name: 'SearchMessage',
	computed: {
    total() {
      return this.$store.getters.total;
    },
    loading() {
      return this.$store.getters.loading;
    },
    suggestion() {
      return this.$store.getters.suggestion;
    }
	},
})
